import list from '@ui/Currencies/currenciesCodes.json'

export const isCrypto = (currency: string) => (!list.includes(currency)) && (currency !== "DEMO");